import {ContainerProps, ControlProps, OptionProps} from "react-select";
import {CSSObject} from "@emotion/styled";

export interface ISelectTheme {
    forms: {
        input_bg: string;
        // input_bg_disabled: string;
        input_color: string;
        input_border: string;
        input_font_size_base: string;
        input_font_size_large: string;
        input_font_size_small: string;
        input_box_shadow: string;
        input_box_shadow_focus: string;
        input_border_radius: string;
        input_border_radius_large: string;
        input_border_radius_small: string;
        input_border_focus: string;
        input_color_placeholder: string;
        input_height_base: number;
        input_height_large: number;
        input_height_small: number;
        // form_group_margin_bottom: string;
        // input_transition: string;
        // input_cursor_disabled: string;
        input_font_weight: number;
        error_message_color: string;
        error_message_input_box_shadow: string;
        //
        // label_color: string;
        // label_font_weight: number;
        // label_font_size: number;
        // label_vertical_margin: string;
        // label_horizontal_margin: string;

        select_option_font_size: string;
        select_option_bg: string;
        select_option_bg_hover: string;
        select_option_bg_selected: string;
        select_option_bg_selected_hover: string;
        select_multi_value_bg: string;
        select_multi_value_border_radius: string;
    };
    padding: {
        padding_base_horizontal: string;
        padding_large_horizontal: string;
        padding_small_horizontal: string;
    };
}

export const selectCustomStyles = (theme: ISelectTheme, asyncSelect = false) => ({
    // any: Hard to tell what Select really expects, some of its own typings extend { [key: string]: any }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control: (provided: CSSObject, state: ControlProps<any, boolean, any>) => ({
        ...provided,
        minHeight:
            state.selectProps.size === "lg"
                ? theme.forms.input_height_large
                : state.selectProps.size === "sm"
                ? theme.forms.input_height_small
                : theme.forms.input_height_base,
        borderColor:
            state.isFocused && !state.selectProps.error
                ? theme.forms.input_border_focus
                : state.selectProps.error
                ? theme.forms.error_message_color
                : theme.forms.input_border,
        borderRadius:
            state.selectProps.size === "lg"
                ? theme.forms.input_border_radius_large
                : state.selectProps.size === "sm"
                ? theme.forms.input_border_radius_small
                : theme.forms.input_border_radius,
        boxShadow:
            state.isFocused && !state.selectProps.error
                ? theme.forms.input_box_shadow_focus
                : state.selectProps.error
                ? theme.forms.error_message_input_box_shadow
                : theme.forms.input_box_shadow,
        backgroundColor: theme.forms.input_bg,
        color: theme.forms.input_color,
        ":hover": {
            borderColor:
                state.isFocused && !state.selectProps.error
                    ? theme.forms.input_border_focus
                    : state.selectProps.error
                    ? theme.forms.error_message_color
                    : theme.forms.input_border
        }
    }),
    indicatorsContainer: (provided: CSSObject) => ({
        ...provided,
        cursor: "pointer"
    }),
    menu: (provided: CSSObject) => ({
        ...provided,
        zIndex: 1000
    }),
    // any: Hard to tell what Select really expects, some of its own typings extend { [key: string]: any }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    option: (provided: CSSObject, state: OptionProps<any, boolean, any>) => ({
        ...provided,
        color: theme.forms.input_color,
        backgroundColor: state.isSelected ? theme.forms.select_option_bg_selected : theme.forms.select_option_bg,
        fontSize: theme.forms.select_option_font_size,
        padding:
            state.selectProps.size === "lg"
                ? `1rem ${theme.padding.padding_large_horizontal}`
                : state.selectProps.size === "sm"
                ? `1rem ${theme.padding.padding_small_horizontal}`
                : `1rem ${theme.padding.padding_base_horizontal}`,
        ":hover": {
            backgroundColor: state.isSelected ? theme.forms.select_option_bg_selected_hover : theme.forms.select_option_bg_hover
        }
    }),
    // any: Hard to tell what Select really expects, some of its own typings extend { [key: string]: any }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    valueContainer: (provided: CSSObject, state: ContainerProps<any, boolean, any>) => ({
        ...provided,
        padding:
            state.selectProps.size === "lg"
                ? `0.3rem ${theme.padding.padding_large_horizontal}`
                : state.selectProps.size === "sm"
                ? `0.3rem ${theme.padding.padding_small_horizontal}`
                : `0.3rem ${theme.padding.padding_base_horizontal}`,
        cursor: asyncSelect ? "text" : "default"
    }),
    placeholder: (provided: CSSObject) => ({
        ...provided,
        color: theme.forms.input_color_placeholder,
        fontSize: theme.forms.input_font_size_base,
        marginLeft: 0,
        marginRight: 0,
        fontWeight: theme.forms.input_font_weight
    }),
    // any: "input" dont recognize CSSObject and hard to tell what it really expects
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    input: (provided: any) => ({
        ...provided,
        margin: 0,
        fontSize: theme.forms.input_font_size_base,
        fontWeight: theme.forms.input_font_weight
    }),
    singleValue: (provided: CSSObject) => ({
        ...provided,
        marginLeft: 0,
        marginRight: 0,
        fontSize: theme.forms.input_font_size_base,
        fontWeight: theme.forms.input_font_weight
    }),
    multiValue: (provided: CSSObject) => ({
        ...provided,
        backgroundColor: theme.forms.select_multi_value_bg,
        borderRadius: theme.forms.select_multi_value_border_radius
    }),
    multiValueLabel: (provided: CSSObject) => ({
        ...provided,
        color: "#fff",
        fontSize: theme.forms.input_font_size_base,
        paddingLeft: "1rem"
    }),
    multiValueRemove: (provided: CSSObject) => ({
        ...provided,
        color: "#fff",
        ":hover": {
            backgroundColor: "unset",
            color: "#fff",
            cursor: "pointer",
            borderTopRightRadius: theme.forms.select_multi_value_border_radius,
            borderTopLeftRadius: theme.forms.select_multi_value_border_radius
        }
    })
});
